import { render, staticRenderFns } from "./GtsToolTips.vue?vue&type=template&id=197c50ff&scoped=true"
import script from "./GtsToolTips.vue?vue&type=script&lang=js"
export * from "./GtsToolTips.vue?vue&type=script&lang=js"
import style0 from "./GtsToolTips.vue?vue&type=style&index=0&id=197c50ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c50ff",
  null
  
)

export default component.exports